export const DEFAULT_LOCALE = 'es-ES';

export const SUPPORTED_LOCALES = [
    'es-ES',
    'en-US',
] as const;

export type AppLocale = typeof SUPPORTED_LOCALES[number];
export type TranslationLanguage = 'es' | 'en';

export function resolveAppLocale(value: unknown): AppLocale {
    if (typeof value !== 'string') {
        return DEFAULT_LOCALE;
    }

    const normalized = value
        .trim()
        .replace('_', '-')
        .toLowerCase();

    if (normalized === 'en' || normalized === 'en-us') {
        return 'en-US';
    }

    return DEFAULT_LOCALE;
}

export function toTranslationLanguage(
    locale: AppLocale,
): TranslationLanguage {
    return locale === 'en-US' ? 'en' : 'es';
}
